import React from 'react';
import { Button } from './ui/button';
import { FileText, Shield, AlertCircle, CheckCircle } from 'lucide-react';

const TrademarkOverview = ({ openPopup }) => {
  const highlights = [
    {
      icon: FileText,
      title: "What is a Trademark?",
      description: "A trademark is a unique identifier—name, logo, slogan, or symbol—that distinguishes your products or services from competitors. It's your brand's legal signature in the marketplace."
    },
    {
      icon: Shield,
      title: "Why Register?",
      description: "Federal trademark registration provides nationwide legal protection, exclusive rights to your brand identity, and the power to prevent others from using confusingly similar marks in your industry."
    },
    {
      icon: AlertCircle,
      title: "Risks Without Protection",
      description: "Without trademark registration, you risk brand dilution, costly legal disputes, loss of brand equity, and potential forced rebranding if someone else registers a similar mark first."
    },
    {
      icon: CheckCircle,
      title: "Our Expertise",
      description: "With 15+ years specializing in trademark law, we navigate the complex USPTO process, conduct thorough searches, and provide strategic guidance to ensure your brand receives maximum protection."
    }
  ];

  return (
    <section className="overview-section" id="overview">
      <div className="section-container">
        <div className="section-header-center">
          <span className="section-label">Trademark Registration Overview</span>
          <h2 className="section-title">
            Understanding Trademark Protection
            <span className="title-highlight"> for Your Business</span>
          </h2>
          <p className="section-description">
            A trademark is more than just a legal formality—it's the foundation of your brand's 
            identity and competitive advantage. Learn why professional trademark registration is 
            essential for protecting your business investment.
          </p>
        </div>

        <div className="overview-grid">
          {highlights.map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="overview-card">
                <div className="overview-card-icon">
                  <Icon size={32} />
                </div>
                <h3 className="overview-card-title">{item.title}</h3>
                <p className="overview-card-description">{item.description}</p>
              </div>
            );
          })}
        </div>

        <div className="overview-cta">
          <p className="overview-cta-text">
            Ready to protect your brand with federal trademark registration?
          </p>
          <Button onClick={openPopup} className="overview-cta-button" size="lg">
            Start Your Trademark Registration
          </Button>
        </div>
      </div>
    </section>
  );
};

export default TrademarkOverview;
